// src/components/CreateSongForm.js

import React, { useState } from "react";
import { useMutation, gql } from "@apollo/client";
import "../styles.css"; // Match your styling

const CREATE_SONG = gql`
  mutation CreateSong($input: CreateSongInput!) {
    createSong(input: $input) {
      id
      title
    }
  }
`;

const CreateSongForm = ({ artistPageId, albumId, refetch, refetchSongs }) => {
  const token = sessionStorage.getItem("token");

  const [newSong, setNewSong] = useState({
    title: "",
    duration: "",
    genre: "",
  });

  const [audioFile, setAudioFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [createSong, { loading: mutationLoading }] = useMutation(CREATE_SONG, {
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    onCompleted: () => {
      refetch?.();
      refetchSongs?.();     // refresh songs
      setNewSong({
        title: "",
        duration: "",
        genre: "",
      });
      setAudioFile(null);
      setErrorMessage("");
    },
  });

  const handleSubmit = async () => {
    if (!token) return setErrorMessage("You must be logged in to upload a song.");
    if (!artistPageId || !albumId) return setErrorMessage("Missing artist or album info.");
    if (!newSong.title || !newSong.duration || !audioFile) {
      return setErrorMessage("Title, duration and audio file are required.");
    }

    const input = {
      ...newSong,
      duration: parseInt(newSong.duration),
      artistPageId,
      albumId,
      audioFile,
    };

    try {
      const { data } = await createSong({ variables: { input } });
      console.log("Song uploaded:", data);
    } catch (error) {
      console.error("Upload error:", error.message);
      setErrorMessage(error.message || "Error uploading song.");
    }
  };

  return (
    <div className="merchandise-form">
      <h2>Upload Song</h2>

      <input
        type="text"
        placeholder="Title"
        value={newSong.title}
        onChange={(e) => setNewSong({ ...newSong, title: e.target.value })}
        className="form-input"
      />

      <input
        type="number"
        placeholder="Duration (in seconds)"
        value={newSong.duration}
        onChange={(e) => setNewSong({ ...newSong, duration: e.target.value })}
        className="form-input"
      />

      <input
        type="text"
        placeholder="Genre"
        value={newSong.genre}
        onChange={(e) => setNewSong({ ...newSong, genre: e.target.value })}
        className="form-input"
      />

      <input
        type="file"
        accept="audio/*"
        onChange={(e) => setAudioFile(e.target.files[0])}
        className="form-file"
      />

      <button onClick={handleSubmit} disabled={mutationLoading} className="form-button">
        {mutationLoading ? "Uploading..." : "Upload Song"}
      </button>

      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default CreateSongForm;
